// Universe listing status — timeline scroll of our events, each marked Listed
// (links to the live Universe listing) or Not listed. Read-only wrapper over
// the shared DistributionListings view: publishing to Universe goes through
// announce / sync-platforms and the per-event editor (the Edit link).

import { useParams } from 'react-router-dom';
import DistributionListings from './DistributionListings.jsx';

export default function UniverseListings() {
  const { tenantSlug } = useParams();
  return (
    <DistributionListings
      title="Universe"
      platform="universe"
      listEndpoint="universe/listings"
      readOnly
      editHref={(e) => `/${tenantSlug}/event/${e.id}/universe`}
      notConnectedMsg="Universe is not connected for this tenant."
    />
  );
}
